var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const formatCurrency = (cents, format) => {
    const money_format = '${{amount}}';
    if (typeof cents == 'string') {
        cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || money_format;
    const defaultOption = (opt, def) => {
        return typeof opt == 'undefined' ? def : opt;
    };
    const formatWithDelimiters = (number, precision, thousands, decimal) => {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');
        if (isNaN(number) || number == null) {
            return 0;
        }
        number = (number / 100.0).toFixed(precision);
        const parts = number.split('.'), dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands), cents = parts[1] ? decimal + parts[1] : '';
        return dollars + cents;
    };
    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, ',', '.');
            break;
    }
    return formatString.replace(placeholderRegex, value);
};
export const getMoneyFormat = (selectedCountry) => {
    switch (selectedCountry.currency.isoCode) {
        case 'IDR':
            return `${selectedCountry.currency.symbol} {{amount_with_comma_separator}}`;
        case 'JPY':
            return `${selectedCountry.currency.symbol}{{amount_no_decimals_with_comma_separator}}`;
        case 'MYR':
            return `${selectedCountry.currency.symbol}{{amount_no_decimals_with_comma_separator}} ${selectedCountry.currency.isoCode}`;
        case 'KRW':
            return `${selectedCountry.currency.symbol}{{amount_no_decimals}}`;
        case 'THB':
            return `{{amount}} ${selectedCountry.currency.symbol}`;
        default:
            return `${selectedCountry.currency.symbol}{{amount}}`;
    }
};
export const getAvailableCurrenciesAPI = () => __awaiter(void 0, void 0, void 0, function* () {
    const storeData = window.thGeolocationData.stores.find((store) => {
        return store.permanent_domain === window.Shopify.shop;
    });
    if (storeData) {
        return yield fetch(`https://threadheads-admin-api-56b7d3006b0b.herokuapp.com/localization/${window.threadheads.adminApiRegion}`)
            .then((res) => {
            return res.json();
        })
            .then((data) => {
            return data.body.data.localization;
        });
    }
    return null;
});
export const getAvailableCurrencies = () => __awaiter(void 0, void 0, void 0, function* () {
    const storeData = window.thGeolocationData.stores.find((store) => {
        return store.permanent_domain === window.Shopify.shop;
    });
    if (storeData) {
        const res = yield fetch(`https://${window.Shopify.shop}/api/2023-07/graphql.json`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': storeData.s,
            },
            body: JSON.stringify({
                query: `
              query {
                localization {
                  availableCountries {
                    currency {
                      isoCode
                      name
                      symbol
                    }
                    isoCode
                    name
                    unitSystem
                  }
                  country {
                    currency {
                      isoCode
                      name
                      symbol
                    }
                    isoCode
                    name
                    unitSystem
                  }
                }
              }
              `,
            }),
        });
        const data = yield res.json();
        return data.data.localization;
    }
    return null;
});
export const getAvailableStores = (myShopifyURL, token) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield fetch(`https://${myShopifyURL}/api/2023-07/graphql.json`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': token,
        },
        body: JSON.stringify({
            query: `
        query {
          localization {
            availableCountries {
              currency {
                isoCode
                name
                symbol
              }
              isoCode
              name
              unitSystem
            }
            defaultCountry: country {
              currency {
                isoCode
                name
                symbol
              }
              isoCode
              name
              unitSystem
            }
          }
        }
      `,
        }),
    });
    const data = yield res.json();
    return data.data.localization;
});
